export const VocabSpecialtySubPicker = {
    'edit': ['Editar', 'Edit'],
    'search': ['Buscar...', 'Search...'],
    'no_results': ['No hay resultados', 'No results'],
  }
    